import React, { useState, useMemo, useEffect } from 'react'
import { Row, Input, Modal, Checkbox } from 'antd'
import styled from 'styled-components'
import { getCookie } from 'helper/cookie'
import '../../../styleLess/signature/editprofesskill.scss'
import { SearchOutlined } from '@ant-design/icons'
import bin from '../../../icons/create/bin.svg'
import path from '../../../icons/create/Path.svg'
import {
  getProfileUser,
  getCallbackskillUser,
} from '../../../api/ProfessionSkills/professionskills'
const ImpacticalContainer = styled.div``
const SkillBox = styled.div``
const Tag = styled.div``
import lang from 'lang/en'

const initalState = {
  information: {
    avatar: '',
    firstname: '',
    lastname: '',
    email: '',
  },
}

const editprofessionskills = (props) => {
  const {
    setModalVision,
    skillListData,
    memberData,
    ModalVision,
    getDataMember,
    dataMember,
  } = props
  const language = getCookie('lang')
  const word = lang[language]
  const token = getCookie('access_token_admin')
  const BorderSelected = true
  const [SearchTerm, setSearchTerm] = useState('')
  const [TagArrayData, SetTagArrayData] = useState([])
  let Selecttotal = TagArrayData.length
  const [information, setInformation] = useState(initalState.information)

  const getProfilefromUser = useMemo(async () => {
    if (memberData) {
      await getProfileUser({
        iduser: memberData,
        token: token,
      })
        .then(async (response) => {
          const { status, data, error } = response
          if (error) {
            return true
          }
          if (status === 200) {
            var skill = data.skill
            if (skill != null) {
              skill = skill.substring(1, skill.length - 1)
              var arrayskill = skill.split(',')

              // สร้าง array ของ skill names จาก dataMember
              const skillNames = data.skill_name ? data.skill_name.split(',') : []

              // สร้าง array สำหรับเก็บ skills ทั้งหมด
              const allSkills = []

              // วนลูปทุก ID ใน arrayskill
              arrayskill.forEach((skillId, index) => {
                const trimmedId = skillId.trim()

                if (trimmedId !== '') {
                  // หาใน skillListData ก่อน
                  const foundSkill = skillListData?.find(
                    (item) => item && item.id.toString() === trimmedId,
                  )

                  if (foundSkill) {
                    // พบข้อมูลใน skillListData (Active)
                    allSkills.push({
                      id: foundSkill.id,
                      skill_name: foundSkill.title,
                      isActive: true,
                    })
                  } else {
                    // ไม่พบข้อมูลใน skillListData (Inactive) - ใช้ชื่อจาก skill_name
                    const skillName = skillNames[index] || `Unknown Skill (${trimmedId})`
                    allSkills.push({
                      id: parseInt(trimmedId),
                      skill_name: skillName,
                      isActive: false,
                      isUnknown: true,
                    })
                  }
                }
              })

              SetTagArrayData(allSkills)
            }
            setInformation((prev) => ({
              ...prev,
              avatar: data.pic_display,
              firstname: data.firstname,
              lastname: data.lastname,
              email: data.email,
            }))
          } else {
            return true
          }
        })
        .catch((error) => {
          console.error(error)
        })
    }
  }, [memberData, skillListData]) // เพิ่ม skillListData ใน dependency

  const onChangeSearch = (e) => {
    setSearchTerm(e.target.value)
  }
  const handleEventSelected = (data) => {
    SelectListAll(data)

    TagArrayData.map((item) => {
      if (item.id == data.id) {
        handleRemove(data.id)
      }
    })
  }

  const SelectListAll = (data) => {
    var addData = true
    for (var i = 0; i < TagArrayData.length; i++) {
      if (TagArrayData[i].id == data.id) {
        addData = false
      }
    }

    if (addData) {
      //เงื่อนไข
      return SetTagArrayData([
        ...TagArrayData,
        {
          id: data.id,
          skill_name: data.title,
        },
      ])
    }
  }
  const RemoveAll = () => {
    const DeletetagAll = TagArrayData.filter((item) => item !== item)
    SetTagArrayData(DeletetagAll)
  }
  const handleRemove = (id) => {
    const newTag = TagArrayData.filter((item) => item.id !== id)
    SetTagArrayData(newTag)
  }

  const renderSkill = () => {
    return skillListData
      ?.filter((item) => {
        // กรองเฉพาะรายการที่มี status เป็น "Active"
        // if (item.status !== 'Active') {
        //   return false
        // }

        // กรองตามคำค้นหา
        if (SearchTerm === '') {
          return true
        } else if (item.title.toLowerCase().includes(SearchTerm.toLowerCase())) {
          return true
        }

        return false
      })
      .map((item, index) => {
        // เพิ่ม index สำหรับ key
        let Focus = 0
        for (var i = 0; i < TagArrayData.length; i++) {
          if (TagArrayData[i].id === item.id) {
            // ใช้ === แทน ==
            Focus = item.id
          }
        }
        return (
          <SkillBox
            key={index} // เพิ่ม key prop
            className={BorderSelected && Focus ? 'SkillBox' : 'active-SkillBox'}
          >
            <Checkbox onChange={() => handleEventSelected(item)} checked={Focus} />
            <div style={{ display: 'grid' }}>
              <p className="cutter-text-line-1">{item.title}</p>
            </div>
          </SkillBox>
        )
      })
  }

  const onCancel = () => {
    setSearchTerm('')
    setModalVision(false)
  }
  const onOk = (skilllist, id) => {
    let ListID = []

    // วนลูปเพื่อเก็บ ID ทั้งหมด (รวม unknown skills)
    for (var i = 0; i < skilllist.length; i++) {
      ListID.push(skilllist[i].id)
    }

    const dataArray = {
      account_id: parseInt(id),
      professional_skill: `${ListID}`, // ส่ง ID ทั้งหมดไป (API จะต้องจัดการ unknown IDs เอง)
    }

    try {
      getCallbackskillUser({
        params: dataArray,
        token: token,
      }).then((res) => {
        getDataMember()
      })
    } catch (error) {
      return error
    }
    setSearchTerm('')
    setModalVision(false)
  }

  // useEffect(() => {
  //   GetAccountByID()
  // }, [token]) // เรียกใช้เมื่อ accountId เปลี่ยนแปลง

  return (
    <Modal
      maskClosable={false}
      className="save-and-cancel-modal edit-width-modal response-width-modal"
      visible={ModalVision}
      onOk={(e) => onOk(TagArrayData, memberData)}
      onCancel={() => onCancel()}
      destroyOnClose={true}
      okText="Save"
    >
      <ImpacticalContainer>
        <div className="ImpacticalContainer">
          <div className="content1">
            <div className="sub-content1">
              <img
                style={{ width: 52, height: 52 }}
                className="imageStyle"
                src={information.avatar}
              ></img>
            </div>
            <div className="sub-content2">
              <Row style={{ display: 'grid' }}>
                <h2 className="cutter-text-line-1">
                  {information.firstname}
                  {'   '}
                  {information.lastname}
                </h2>
              </Row>
              <div style={{ display: 'grid' }}>
                <h4 className="cutter-text-line-1">{information.email}</h4>
              </div>
            </div>
          </div>
          <div className="content2">
            <div className="sub-content1">
              <div className="numberselect">
                <a>
                  {Selecttotal} {word['Skills_Selected']}
                </a>
              </div>
              <Tag className="Tag">
                {TagArrayData &&
                  TagArrayData.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className={`Box ${item.isUnknown ? 'unknown-skill' : ''}`}
                        onClick={() => handleRemove(item.id)}
                      >
                        <span
                          className="tagname"
                          title={
                            item.isUnknown ? 'This skill is no longer available' : ''
                          }
                        >
                          {item.skill_name}
                          {item.isUnknown}
                        </span>
                        <img className="iconpath" src={path}></img>
                      </div>
                    )
                  })}

                <img
                  className={TagArrayData.length >= 2 ? 'bin' : 'activebin'}
                  src={bin}
                  onClick={() => RemoveAll()}
                ></img>
              </Tag>
            </div>

            <div className="sub-content2">
              <Input
                suffix={<SearchOutlined />}
                placeholder="Search By Skill Name"
                type="text"
                value={SearchTerm}
                onChange={onChangeSearch}
                size="large"
              />
            </div>
          </div>
          <div className="content3">
            <h4>{word['Select_professional_skills']}</h4>
            <div className="skillall-container">{renderSkill()}</div>
          </div>
        </div>
      </ImpacticalContainer>
    </Modal>
  )
}
export default editprofessionskills
